import {CountUp} from 'countup.js'
import AOS from 'aos'
import lozad from 'lozad'
import {
	setBackgroundElement,
	detectCloseElement,
	buttonToTop,
	clickScrollToDiv,
	appendCaptchaASP,
} from './helper'
import {header} from './header'
import swiperInit from './swiper'
import {clickLoadMoreAjax} from './utils'
$(document).ready(function () {
	setBackgroundElement()
	header.init()
	swiperInit()
	appendCaptchaASP()
	countUpNumber()
	clickScrollByPhase()
	// clickExpandContentPolicy()
	// handleExpandListProvider()
	ToggleExpandCategory()
	appendBreadcrumb()
	SelectSortProvider()
	handleToggleBrand()
	AOS.init()
	buttonToTop()
	clickLoadMoreAjax()
	AppendDescImage()
	AddFancyboxImage()
	handleReport()
	selectDefaultValueContact()
	moveContact()
})
/*==================== Select Default Value Contact ====================*/
function selectDefaultValueContact () {
	const $select = $('#ctl00_mainContent_ctl05_ctlce0f46ece6fe4806b2593b24fc9cd826_ddce0f46ece6fe4806b2593b24fc9cd826')
	if (!$select.length) return
	const firstValue = $select.find('option').eq(1).val()
	$select.val(firstValue).change()
}

/*==================== Add Fancybox Imgage ====================*/
function AddFancyboxImage() {
	// if (!$('.section-activity-detail').length) return
	$('.wrap-img-fancybox img').each(function () {
		const imgSrc = $(this).attr('src')
		const title = $(this).attr('title')
		$(this).wrap(
			`<a href="${imgSrc}"  data-caption="${title}"  data-fancybox="gallery" class="cursor-popup"></a>`
		)
	})
}

/*==================== Append Description Image ====================*/

function AppendDescImage() {
	$('.news-detail .full-content img').each(function () {
		const title = $(this).attr('title')
		const url = $(this).attr('src')
		$(this).wrap(
			`<a href="${url}" class="cursor-popup" data-fancybox="gallery" data-caption="${title}"></a>`
		)
		if (title) {
			$(this).after(`<figcaption>${title}</figcaption>`)
		}
	})
}

/*====================  ====================*/

function handleReport() {
	if (!$('.section-infomation-disclosure').length) return
	$('.section-infomation-disclosure .swiper-slide').last().find('a').trigger('click')
}
/*==================== SelectSortProvider ====================*/
function SelectSortProvider() {
	function processAjax(url, nodeElement) {
		$.ajax({
			url: url,
			beforeSend: function (data) {
				$('.loading').addClass('active')
			},
			success: async function (data) {
				$('.ajaxResponse').html($(data).find('.ajaxResponse').html())
				if ($('.pages.newspager').length) {
					if ($(data).find('.pages').length) {
						$('.pages.newspager').html($(data).find('.pages.newspager').html())
					} else {
						$('.pages').html('')
					}
				} else {
					$('.ajaxResponse').append($(data).find('.pages.newspager').html())
				}
				$('.loading').removeClass('active')
				observer.observe()
			},
		})
	}
	$('.select-link select').on('change', function () {
		let value = $(this).val()
		window.location.href = value
	})
	$('.select-sort select').on('change', function () {
		$(this).parent().addClass('active')
		let value = $(this).val()
		processAjax(value)
	})
	let ajaxTimeoutId
	$('.ajaxLink').on('click', function (e) {
		e.preventDefault()
		$('.ajaxLink').removeClass('active')
		let value = $(this).attr('href')
		$(this).addClass('active')
		debounceAjax(value)
		return false
	})
	function debounceAjax(value) {
		if (ajaxTimeoutId) {
			clearTimeout(ajaxTimeoutId)
		}
		ajaxTimeoutId = setTimeout(() => {
			processAjax(value)
		}, 100)
	}
}

/*==================== Append Breadcrumb ====================*/

function appendBreadcrumb() {
	if (!$('.page-banner-main').length) return
	$('.global-breadcrumb').appendTo('.page-banner-main .wrap-global-breadcrumb')
}

/*==================== ToggleExpandCategory ====================*/
function ToggleExpandCategory() {
	$('.title-tab').on('click', function () {
		$(this).toggleClass('active')
		$(this).parent().find('.tab-style-3').slideToggle()
	})
}
/*==================== Provider: Handle expand list ====================*/

function handleToggleBrand() {
	const $btnToggle = $('.icon-toggle')
	if ($btnToggle) {
		$btnToggle.on('click', function () {
			$(this).toggleClass('active')
			$('.wrap-list').slideToggle()
		})
	}
}

function handleExpandListProvider() {
	const $nodeProviderList = $('.provider-list-item')
	const $nodeProvierItem = $('.provider-item').outerHeight()
	const heightInit = $nodeProvierItem * 3
	$nodeProviderList.each(function (index) {
		const totalHeight = $(this).children().outerHeight()
		const $nodeParrentCurrent = $(this)
		const numberChild = $(this).find('.provider-item').length
		if (numberChild < 3) return
		$(this).css('height', heightInit)
		$(this)
			.parent()
			.find('.btn-view-more')
			.on('click', function () {
				if ($(this).hasClass('expand')) {
					$nodeParrentCurrent.css('height', heightInit)
					$(this).find('span').text('Xem thêm')
				} else {
					$nodeParrentCurrent.css('height', totalHeight)
					$(this).find('span').text('Rút gọn')
				}
				$(this).toggleClass('expand')
			})
	})
}

/*==================== ClickScrollToDiv ====================*/
function clickScrollByPhase() {
	const isDirection = {
		isPrev: 0,
		isNext: 1,
	}
	clickScrollToDiv('.wrap-history-develop .wrap-phase li a', () =>
		$('header').outerHeight()
	)
	// HandleScroll
	$('.wrap-select select').on('change', function () {
		// let value = $(this).children("option:selected").val();
		// $("html, body").animate(
		// 	{
		// 		scrollTop: $(`#${value}`).offset().top,
		// 	},
		// 	800
		// );
	})
	async function setValue(val, direction) {
		let valSet = ''
		if (direction == isDirection.isPrev) {
			const value = $(`option[value="${val}"]`).prev().val()
			valSet = value ? value : val
		} else {
			const value = $(`option[value="${val}"]`).next().val()
			valSet = value ? value : val
		}
		// $(".wrap-phase-mobile .wrap-select select").val(valSet).change();
		if (valSet == val) return
		const heightHeader = Number($('header').outerHeight()) + 100
		$('html, body').animate(
			{
				scrollTop: Number($(`#${valSet}`).offset().top) - heightHeader,
			},
			800
		)
	}
	$('.wrap-phase-mobile .btn-prev').on('click', function () {
		let value = $(
			'.wrap-phase-mobile .wrap-select select option:selected'
		).val()
		setValue(value, isDirection.isPrev)
	})
	$('.wrap-phase-mobile .btn-next').on('click', function () {
		let value = $(
			'.wrap-phase-mobile .wrap-select select option:selected'
		).val()
		setValue(value, isDirection.isNext)
	})
}
const observerPhase = new IntersectionObserver(
	(entries, observe) => {
		entries.forEach(entry => {})
	},
	{
		threshold: [1],
		rootMargin: '0px',
	}
)
const nodeElementsTEst = document.querySelectorAll(
	'.wrap-item-phase .text-phase-main'
)
nodeElementsTEst.forEach(ele => {
	observerPhase.observe(ele)
})

const nodeElements = document.querySelectorAll('.text-phase-main')

window.addEventListener('scroll', function () {
	nodeElements.forEach(nodeElement => {
		const rect = nodeElement.getBoundingClientRect()
		const position = rect.top + window.scrollY
		const viewportTop = window.scrollY
		const threshold = 200
		const namePhase = $(nodeElement).data('phase')
		if (position <= viewportTop + threshold) {
			nodeElement.classList.add('active')
			$(`a[href="#${namePhase}"]`)
				.addClass('active-scroll')
				.parent()
				.siblings()
				.find('a')
				.removeClass('active-scroll')
			$('.wrap-phase-mobile .wrap-select select').val(namePhase).change()
		} else {
			$(`a[href="#${namePhase}"]`).removeClass('activ-scroll')
			nodeElement.classList.remove('active')
		}
	})
})

/*==================== Count Up ====================*/

function countUpNumber() {
	const nodeElement = document.querySelectorAll('.count-num')
	for (var i = 0; i < nodeElement.length; i++) {
		const dataValue = nodeElement[i].getAttribute('data-number')
		var numAnim = new CountUp(nodeElement[i], dataValue)
		numAnim.start()
	}
}
if ($('.count-num').length > 0) {
	var callback = function (e) {
		e.forEach(async function (e) {
			if (e.isIntersecting) {
				await new Promise(r => setTimeout(r, 500))
				countUpNumber()
			}
		})
	}
	var observer = new IntersectionObserver(callback)
	var animationItems = document.querySelectorAll('.count-num-section')
	animationItems.forEach(function (e) {
		observer.observe(e)
	})
}
/*==================== Policy - Click Expand Content  ====================*/
function clickExpandContentPolicy() {
	if (!$('.section-page-policy').length) return
	const $nodeBox = $('.wrap-content-main')
	const $button = $('.section-page-policy .btn-view-more')
	const paddingNodeBox = Number($nodeBox.css('padding-top').slice(0, 2))
	const totalHeightInit =
		$('.wrap-content-main .box-content-divide').eq(0).outerHeight() +
		$('.wrap-content-main .box-content-divide').eq(1).outerHeight() +
		paddingNodeBox * 2
	const totalHeight =
		$nodeBox.find('.hidden-content').outerHeight() + paddingNodeBox * 2
	$nodeBox.css('height', totalHeightInit)
	// $('.section-page-policy .btn-view-more').on('click', function () {
	// 	$nodeBox.css('height', totalHeight + 80)
	// })
	$button.on('click', function () {
		if ($(this).hasClass('expand')) {
			$nodeBox.css('height', totalHeightInit)
			$(this).find('span').text('Xem thêm')
		} else {
			$nodeBox.css('height', totalHeight)
			$(this).find('span').text('Rút gọn')
		}
		$(this).toggleClass('expand')
	})
}
/*==================== Aos Init ====================*/

/*==================== Lazyload JS ====================*/
var observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()
